import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { vFlex, hFlex } from '../../utils/sxChunks.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var baseContainerSx = {
  d: "flex",
  flexDirection: "column",
  flexShrink: 0,
  alignItems: "stretch",
  w: "100%",
  pos: "relative",
  brad: "base.borderRadius.x4",
  overflow: "hidden",
  boxShadow: "base.shadow.100",
  transitionProperty: "border, box-shadow, translate",
  transitionDuration: "base.motion.normal.fast.cssDuration",
  transitionTimingFunction: "base.motion.normal.fast.cssEase",
  "&::before, &::after": {
    content: '""',
    pos: "absolute",
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    brad: "base.borderRadius.x4",
    border: "solid transparent",
    borderWidth: "base.border.size.400",
    pointerEvents: "none",
    userSelect: "none",
    transitionProperty: "border-color",
    transitionDuration: "base.motion.normal.fast.cssDuration",
    transitionTimingFunction: "base.motion.normal.fast.cssEase"
  },
  "&::after": {
    borderWidth: "base.border.size.200"
  },
  "&.Card--selected::after": {
    borderColor: "base.color.translucent.standard.1000"
  },
  "&.Card--isClickable": {
    cursor: "pointer"
  },
  "& .AspectRatioImage, & .Video": {
    scale: "1.0",
    transformOrigin: "bottom center",
    transitionProperty: "scale",
    transitionDuration: "base.motion.normal.fast.cssDuration",
    transitionTimingFunction: "base.motion.normal.fast.cssEase"
  },
  "&.Card--isClickable:hover": {
    boxShadow: "base.shadow.300",
    translate: function translate(_ref) {
      var base = _ref.base;
      return "0 -".concat(base.spacing.x2);
    },
    "& .AspectRatioImage, & .Video": {
      scale: "1.05"
    }
  },
  "&.Card--isClickable:active": {
    boxShadow: "base.shadow.200",
    translate: function translate(_ref2) {
      var base = _ref2.base;
      return "0 -".concat(base.spacing.x1);
    }
  },
  "&.Card--elevation1": {
    bgc: "base.color.neutral.900",
    "&.Card--isClickable:hover": {
      bgc: "base.color.neutral.700",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.700"
      }
    },
    "&.Card--isClickable:active": {
      bgc: "base.color.neutral.800",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.800"
      }
    },
    "&.Card--selected&::before": {
      borderColor: "base.color.neutral.900"
    }
  },
  "&.Card--elevation2": {
    bgc: "base.color.neutral.800",
    "&.Card--isClickable:hover": {
      bgc: "base.color.neutral.600",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.600"
      }
    },
    "&.Card--isClickable:active": {
      bgc: "base.color.neutral.700",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.700"
      }
    },
    "&.Card--selected&::before": {
      borderColor: "base.color.neutral.800"
    }
  },
  "&.Card--elevation3": {
    bgc: "base.color.neutral.700",
    "&.Card--isClickable:hover": {
      bgc: "base.color.neutral.500",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.500"
      }
    },
    "&.Card--isClickable:active": {
      bgc: "base.color.neutral.600",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.600"
      }
    },
    "&.Card--selected&::before": {
      borderColor: "base.color.neutral.700"
    }
  },
  "&.Card--elevation4": {
    bgc: "base.color.neutral.600",
    "&.Card--isClickable:hover": {
      bgc: "base.color.neutral.500",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.500"
      }
    },
    "&.Card--isClickable:active": {
      bgc: "base.color.neutral.500",
      "&.Card--selected&::before": {
        borderColor: "base.color.neutral.500"
      }
    },
    "&.Card--selected&::before": {
      borderColor: "base.color.neutral.600"
    }
  },
  "&.Card--elevation5": {
    bgc: "base.color.neutral.500",
    "&.Card--selected&::before": {
      borderColor: "base.color.neutral.500"
    }
  }
};
var baseFramedSx = {
  d: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: function top(_ref3) {
    var base = _ref3.base;
    return "-".concat(base.spacing.x8);
  },
  left: "base.spacing.x6",
  overflow: "hidden",
  w: "base.icon.size.500"
};
var textContainerSx = _objectSpread(_objectSpread({}, vFlex), {}, {
  pt: "base.spacing.x6",
  px: "base.spacing.x6",
  pb: "base.spacing.x6",
  pos: "relative"
});
var buttonsContainerSx = _objectSpread(_objectSpread({}, hFlex), {}, {
  gap: "base.spacing.x2",
  px: "base.spacing.x6",
  pb: "base.spacing.x8",
  alignItems: "center",
  mt: "auto"
});
var framedLogoContainerSx = _objectSpread(_objectSpread({}, baseFramedSx), {}, {
  aspectRatio: 1
});
var framedLogoSx = {
  width: "80%"
};

export { framedLogoSx as a, baseFramedSx as b, buttonsContainerSx as c, baseContainerSx as d, framedLogoContainerSx as f, textContainerSx as t };
//# sourceMappingURL=styles.js.map
